import React from 'react'
import {Link} from 'react-router-dom'
import styled from 'styled-components'
import chef from '../../assets/img/chef.png'
import {whites} from "../../theme/colors";

const Logo: React.FC = () => {
    return (
        <StyledLogo href="https://nsure.network/#/"  target="_blank">
            <img src={chef} height="50" style={{marginTop: -4}}/>
            <StyledText>
                Nsure.Network
            </StyledText>
        </StyledLogo>
    )
};

const StyledLogo = styled.a`
  align-items: center;
  display: flex;
  justify-content: center;
  margin: 0;
  min-height: 44px;
  min-width: 44px;
  padding: 0;
  text-decoration: none;
`;

const StyledText = styled.span`
  color: ${(props) => props.theme.color.white};
  font-size: 20px;
  font-weight: 700;
  letter-spacing: 0.03em;
  @media (max-width: 768px) {
    display: none;
  }
`;

const MasterChefText = styled.span`
`;

export default Logo
